import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { useSelector } from 'react-redux'
axios.defaults.baseURL = process.env.REACT_APP_URL

axios.interceptors.request.use(function (config: any) {
  // Do something before request is sent
  config.headers.post['Content-Type'] = 'application/json'
  config.headers.common.Accept = 'application/json'
  // config.headers.post['Access-Control-Allow-Origin'] = '*'

  const userObject = localStorage.getItem('__session_polac_physical')
  if (userObject !== null) { config.headers.common.Authorization = 'Bearer ' + JSON.parse(userObject)?.token }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
axios.interceptors.response.use(function (config: any) {
  config.headers['cache-control'] = 'no-cache, no-store, must-revalidate'
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// const admissionId = () => {
//   const add = useSelector((state: any) => state.admissionId)
//   return add
// }
const admissionId = localStorage.getItem('admissionId')
// const result = admissionId()
// console.log('ADD', admissionId)
// superadmin
const applicantsService = {

  getAllDataAx: async (page: number, resultPerPage: number, filter: string) => {
    return await axios.get(`/subadmin/pscreen/list?admissionId=${admissionId}&page=${page}&resultPerPage=${resultPerPage}&filter=${filter}`)
  },

  getAllDataSemantic: async (page: number, resultPerPage: number, filter: string, state: number, lga: number) => {
    return await axios.get(`/cpanel/fetch-list?page=${page}&resultPerPage=${resultPerPage}&filter=${filter}&lga[]=${lga}&state[]=${state}&view=semantic`)
  },

  getJobList: async () => {
    return await axios.get('/cpanel/job-list')
  },

  getCounters: async () => {
    return await axios.get(`/subadmin/pscreen/counters?admissionId=${admissionId}`)
  },
  getSetting: async () => {
    return await axios.get('/cpanel/admission-settings')
  },
  getSingleApplicant: async (nin: string) => {
    return await axios.get(`/subadmin/pscreen/query?nin=${nin}&admissionId=${admissionId}`)
  },

  submitPhysicalScreening: async (data: any) => {
    return await axios.post(`/subadmin/pscreen/save?admissionId=${admissionId}`, data)
  },

  submitPScreening: async (formData: any) => {
    return await axios.post(`/subadmin/pscreen/save?admissionId=${admissionId}`, formData)
  },

  getAllDownload: async () => {
    return await axios.get('/cpanel/list-report-file')
  },

  getAllDefault: async (page: number, resultPerPage: number, filter: string) => {
    return await axios.get(`/cpanel/fetch-list?page=${page}&resultPerPage=${resultPerPage}&filter=${filter}`)
  },

  getAllAptitude: async (page: number, resultPerPage: number, filter: string, state: number, lga: number, score: number) => {
    return await axios.get(`/cpanel/fetch-list?page=${page}&resultPerPage=${resultPerPage}&filter=${filter}&lga[]=${lga}&state[]=${state}&score=${score}`)
  },

  downloadSelected: async (page: number, resultPerPage: number, filter: string, state: number, lga: number, score: number, action: string, extension: string) => {
    return await axios.get(`/cpanel/fetch-list?page=${page}&resultPerPage=${resultPerPage}&filter=${filter}&lga[]=${lga}&state[]=${state}&score=${score}&action=${action}&extension=${extension}`)
  },

  downloadSelectedNoScore: async (page: number, resultPerPage: number, filter: string, state: number, lga: number, action: string, extension: string) => {
    return await axios.get(`/cpanel/fetch-list?filter=${filter}&lga[]=${lga}&state[]=${state}&score=50&download=1`)
  },

  downloadUrl: async (uuid: any) => {
    return await axios.get(`/cpanel/download?uuid=${uuid}`)
  },

  getStatistics: async (renew: number) => {
    return await axios.get(`/subadmin/pscreen/counters?admissionId=${admissionId}&renew=${renew}`)
  },

  getMedicalReport: async (nin: string | undefined) => {
    return await axios.get(`/cpanel/medical/extract-report?nin=${nin}`)
  },

  getMedStatistics: async (filterStats: any) => {
    return await axios.get(`/cpanel/medical/counters?filter=${filterStats}`)
  },
  getInstStatistics: async (filterStats: any) => {
    return await axios.get(`/cpanel/institution/counters?institute=${filterStats}`)
  },
  getAppStatistics: async () => {
    return await axios.get('/cpanel/form-submission-count?jobId=2')
  },
  search: async (nin: string | number) => {
    console.log('nin', nin)
    return await axios.get(`/cpanel/query?nin=${nin}`)
  },
  getOfficers: async (page: any, resultPerPage: any, filter: any, stateId: any, lgaId: any) => {
    return await axios.get('/cpanel/institution/staff-list')
  },
  getCollegeList: async () => {
    return await axios.get('/cpanel/institution/list-institute')
  },
  getPostableFormation: async () => {
    return await axios.get('/cpanel/list-recruit-postable-formation')
  },

  getAllCollegeApplicant: async (page: any, resultPerPage: any, filter: any) => {
    return await axios.get(`/cpanel/institution/applicant?page=${page}&resultPerPage=${resultPerPage}&filter=${filter}`)
  },
  getSingleCollegeApplicant: async (id: any, filter: any, page: any, resultPerPage: any) => {
    return await axios.get(`/cpanel/institution/applicant?institute=${id}&filter=${filter}&page=${page}&resultPerPage=${resultPerPage}`)
  },
  asignCollege: async (data: any) => {
    return await axios.post('/cpanel/institution/assign-institute', data)
  },
  getInstitution: async (page: number, filter: string) => {
    return await axios.get(`/cpanel/fetch-list?page=${page}&resultPerPage=50&filter=${filter}&lga[]=0&state[]=0&jobId=1`)
  },
  asignOfficer: async (page: any, resultPerPage: any, filter: any, stateId: any, lgaId: any) => {
    return await axios.get('/cpanel/institution/assign-institute')
  },
  getCollege: async (page: any, resultPerPage: any, filter: any) => {
    return await axios.get(`/cpanel/fetch-list?filter=${filter}`)
  },
  recreen: async (data: any) => {
    return await axios.post('/cpanel/pscreen/save', data)
  }

}

export default applicantsService
